module.exports = __webpack_public_path__ + "img/password-change-success.f4035ccf.svg";